import { render, staticRenderFns } from "./PatrolProblemReportDetail.vue?vue&type=template&id=0c0bbc5c&scoped=true"
import script from "./PatrolProblemReportDetail.vue?vue&type=script&lang=js"
export * from "./PatrolProblemReportDetail.vue?vue&type=script&lang=js"
import style0 from "./PatrolProblemReportDetail.vue?vue&type=style&index=0&id=0c0bbc5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0bbc5c",
  null
  
)

export default component.exports